exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contentParagraph {\n  font-size: 13px; }\n\n.severityBackOne {\n  background-color: #f1f1f1;\n  text-align: center; }\n\n.severityBackTwo {\n  background-color: #deeaf6;\n  text-align: center; }\n\n.severityBackThree {\n  background-color: #e2efd9;\n  text-align: center; }\n\n.severityBackFour {\n  background-color: white; }\n\n.severitySubHeading {\n  font-size: 12px;\n  font-weight: 700; }\n\n.severitySubContent {\n  font-size: 11px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/audit-management/checklist-referance-modal/checklist-referance-modal.component.scss
// module id = ../../../../../src/app/audit-management/checklist-referance-modal/checklist-referance-modal.component.scss
// module chunks = main